import { CreditCardOutlined, ExclamationOutlined, SettingOutlined } from '@ant-design/icons';
import { Avatar, Badge, Dropdown, Flex, Typography } from 'antd';
import { signOut } from 'next-auth/react';
import Link from 'next/link';
import { useCurrentUser } from '../../hooks/data/user';
import classes from './user-block.module.css';

const { Text } = Typography;

function UserBlock() {
   const { user, error, isLoading } = useCurrentUser();

   const handleLogout = () => {
      signOut({
         callbackUrl: '/',
      });
   };
   if (isLoading) {
      return <div>Loading...</div>;
   }
   if (!user && !error) {
      return (
         <Avatar size={30} style={{ cursor: 'pointer', fontSize: 15, background: '#ff4d4f' }}>
            <ExclamationOutlined />
         </Avatar>
      );
   }

   const items = [
      {
         label: <Link href={`/account/settings`}>{user.email}</Link>,
         key: 'email',
         icon: (
            <Avatar size="small">
               {user.name?.length > 0 ? user.name[0] : user.email?.length > 0 ? user.email[0] : 'U'}
            </Avatar>
         ),
      },
      {
         type: 'divider',
      },
      {
         label: <Link href={`/account/settings`}>Settings</Link>,
         key: 'settings',
         icon: <SettingOutlined />,
      },
      {
         label: <Link href={`/account/subscription`}>Subscription</Link>,
         key: 'subscription',
         icon: <CreditCardOutlined />,
      },
      {
         type: 'divider',
      },
      {
         label: 'Logout',
         key: 'logout',
         icon: <i className="fi fi-rr-sign-out-alt" style={{ fontSize: 12 }} />,
         onClick: () => {
            handleLogout();
         },
      },
   ];

   return (
      <Dropdown arrow menu={{ items }}>
         <div className={classes.userContainer}>
            <div className={classes.info}>
               <Flex vertical gap={4} align="flex-end">
                  <Text type="secondary" style={{ fontSize: 14, lineHeight: 1 }}>
                     {user.name}
                  </Text>
                  <Text type="secondary" style={{ fontSize: 10, lineHeight: 1 }}>
                     {user.email}
                  </Text>
               </Flex>
            </div>
            <Badge
               count={
                  user.isPremium ? <i className="fi fi-sr-star" style={{ fontSize: 10, color: '#fff' }} /> : 0
               }
               offset={[-4, 4]}
            >
               <Avatar
                  src={user.avatar}
                  alt={user.name}
                  size={30}
                  style={{ cursor: 'pointer', fontSize: 15 }}
               >
                  {user?.name?.length > 0 ? user.name[0] : user?.email?.length > 0 ? user.email[0] : 'U'}
               </Avatar>
            </Badge>
         </div>
      </Dropdown>
   );
}
export default UserBlock;
